export default __webpack_public_path__ + "static/media/Maul of Conajohara.5df58247.jpg";